import React from 'react';
import { View } from 'react-native';

export const WinGradient = () => {
    return <View />;
};
